import { useRef, useState } from "react";
import { Play } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLanguage } from "../i18n/LanguageContext";
import { SOCIAL } from "../data/social";

const Corners = () => (
    <>
        <span aria-hidden="true" className="absolute -top-2 -left-2 w-8 h-8 border-t border-l border-[#c9a24b]" />
        <span aria-hidden="true" className="absolute -top-2 -right-2 w-8 h-8 border-t border-r border-[#c9a24b]" />
        <span aria-hidden="true" className="absolute -bottom-2 -left-2 w-8 h-8 border-b border-l border-[#c9a24b]" />
        <span aria-hidden="true" className="absolute -bottom-2 -right-2 w-8 h-8 border-b border-r border-[#c9a24b]" />
    </>
);

export const InfluencerOficial = () => {
    const { t } = useLanguage();
    const n = t.influencer;
    const ref = useRef(null);
    const [playing, setPlaying] = useState(false);

    const play = () => {
        setPlaying(true);
        const v = ref.current;
        if (v) { v.muted = false; v.play().catch(() => {}); }
    };

    return (
        <section id="influencer-oficial" className="py-14 sm:py-20 scroll-mt-24" data-testid="influencer-section">
            <div className="mx-auto max-w-[1300px] px-5 sm:px-10 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
                <Reveal className="lg:col-span-7 order-2 lg:order-1">
                    <p className="font-caps text-[10px] sm:text-[11px] tracking-[0.35em] uppercase text-[#c9a24b]" data-testid="influencer-label">{n.label}</p>
                    <h2 className="font-display font-medium text-4xl sm:text-5xl lg:text-6xl text-[#efe6d6] leading-[1.05] mt-5" data-testid="influencer-nome">{n.nome}</h2>
                    <p className="mt-4 font-display italic font-light text-xl sm:text-2xl text-[#ecd49b]/90" data-testid="influencer-titulo">{n.titulo}</p>
                    <p className="mt-7 font-light text-sm sm:text-base text-[#efe6d6]/70 leading-relaxed max-w-xl" data-testid="influencer-texto">{n.texto}</p>
                    <div className="mt-8 flex flex-wrap gap-3">
                        {!playing && (
                            <button type="button" onClick={play} data-testid="influencer-play-cta"
                                className="group inline-flex items-center gap-2 border border-[#c9a24b]/60 px-5 py-2.5 font-caps text-[10px] tracking-[0.22em] uppercase text-[#c9a24b] hover:bg-[#c9a24b] hover:text-[#070503] transition-colors duration-400">
                                <Play size={13} fill="currentColor" /> {n.play}
                            </button>
                        )}
                        <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" data-testid="influencer-instagram"
                            className="inline-flex items-center gap-2 border border-[#c9a24b]/30 px-5 py-2.5 font-caps text-[10px] tracking-[0.22em] uppercase text-[#efe6d6]/70 hover:border-[#c9a24b]/70 hover:text-[#efe6d6] transition-colors duration-400">
                            @fadosamesa
                        </a>
                    </div>
                </Reveal>

                <Reveal delay={0.1} className="lg:col-span-5 order-1 lg:order-2 flex justify-center">
                    <figure className="w-full max-w-[320px] sm:max-w-[340px]">
                        <div className="relative border border-[#c9a24b]/60 p-2 bg-[#0a0705] shadow-[0_30px_80px_-30px_rgba(201,162,75,0.35)]">
                            <Corners />
                            <div className="relative aspect-[9/16] overflow-hidden bg-black">
                                <video ref={ref} src="/videos/nelson-jackson.mp4" poster="/videos/nelson-jackson-poster.webp"
                                    controls={playing} playsInline preload="metadata" onEnded={() => setPlaying(false)}
                                    className="w-full h-full object-cover" data-testid="influencer-video" />
                                {!playing && (
                                    <button type="button" onClick={play} aria-label={n.play} data-testid="influencer-play-overlay"
                                        className="group absolute inset-0 flex items-center justify-center bg-gradient-to-t from-black/70 via-black/10 to-transparent">
                                        <span className="flex items-center justify-center w-16 h-16 rounded-full border border-[#c9a24b] bg-[#070503]/70 backdrop-blur-md group-hover:scale-110 group-hover:bg-[#c9a24b] transition-[transform,background-color] duration-400">
                                            <Play size={22} className="text-[#c9a24b] group-hover:text-[#070503] translate-x-0.5 transition-colors duration-400" fill="currentColor" />
                                        </span>
                                    </button>
                                )}
                            </div>
                        </div>
                        <figcaption className="mt-4 font-caps text-[9px] tracking-[0.25em] uppercase text-[#c9a24b]/70 text-center" data-testid="influencer-legenda">{n.legenda}</figcaption>
                    </figure>
                </Reveal>
            </div>
        </section>
    );
};
